import clsxm from "@/lib/clsxm";
import type {FC, ReactNode} from "react";

export type GlowingGradientBorderProps = {
  children?: ReactNode;
  className?: string;
  containerClassName?: string;
  effectClassName?: string;
  enabled?: boolean;
};

export const GlowingGradientBorder: FC<GlowingGradientBorderProps> = ({
  children,
  className,
  containerClassName,
  effectClassName,
  enabled = true,
}) => {
  return (
    <div className={clsxm("group relative", containerClassName)}>
      <div
        className={clsxm(
          "absolute inset-0 bg-[linear-gradient(var(--button-gradient))] opacity-0 blur-sm transition duration-500",
          enabled && "group-hover:opacity-100",
          effectClassName,
        )}
      />
      <div className={clsxm("relative z-10", className)}>{children}</div>
    </div>
  );
};
